import axios from "../utils/axios";

export const getHaystackersBlogs = async (params = {}) => {
  try {
    const response = await axios.get("/admin/haystackers-blogs", { params });
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch blogs");
  }
};

export const getHaystackersBlogById = async (blogId) => {
  try {
    const response = await axios.get(`/admin/haystackers-blogs/${blogId}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to fetch blog");
  }
};

export const createHaystackersBlog = async (blogData) => {
  try {
    const response = await axios.post("/admin/haystackers-blogs", blogData);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to create blog");
  }
};

export const updateHaystackersBlog = async (blogId, blogData) => {
  try {
    const response = await axios.put(
      `/admin/haystackers-blogs/${blogId}`,
      blogData,
    );
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to update blog");
  }
};

export const deleteHaystackersBlog = async (blogId) => {
  try {
    const response = await axios.delete(`/admin/haystackers-blogs/${blogId}`);
    return response.data;
  } catch (error) {
    throw new Error(error.response?.data?.message || "Failed to delete blog");
  }
};
